/**
 * @file 百度App ua校验
 * @author weijiaxun <weijiaxun@baidu.com>
 */
import { IS_BOX } from '@baidu/eop-box/es/os';
export default function is() {
    return IS_BOX;
}
//# sourceMappingURL=is.js.map